module.exports = __webpack_public_path__ + "img/plane.f1206322.png";